import { child, ref } from "firebase/database";
import { httpsCallable } from "firebase/functions";
import { useListVals } from "react-firebase-hooks/database";
import { fbDatabase, fbFunctions } from "../firebase";
import { InviteData, inviteTransform } from "./invite.types";

export * from "./invite.types";

// RTDB refs
export function refInvites(boardUid: string) {
  return ref(fbDatabase, `invites/${boardUid}`);
}
export function refInvite(boardUid: string, requestorUid: string) {
  return child(refInvites(boardUid), requestorUid);
}

// Hook options
const inviteOptions = { keyField: 'uid' as const, transform: inviteTransform };

// Real-time hook: all invites for a board
export function useInvites(boardUid: string) {
  return useListVals<InviteData>(refInvites(boardUid), inviteOptions);
}

// Callable wrappers
export async function requestBoardInvite(boardUid: string): Promise<boolean> {
  const fn = httpsCallable<{ boardUid: string }, { success: boolean }>(fbFunctions, "requestBoardInvite");
  return (await fn({ boardUid })).data.success;
}

export async function resolveInvite(boardUid: string, requestorUid: string, action: "approve" | "deny"): Promise<boolean> {
  const fn = httpsCallable<{ boardUid: string; requestorUid: string; action: string }, { success: boolean }>(fbFunctions, "resolveInvite");
  return (await fn({ boardUid, requestorUid, action })).data.success;
}

export async function deleteInvite(boardUid: string, requestorUid: string): Promise<boolean> {
  const fn = httpsCallable<{ boardUid: string; requestorUid: string }, { success: boolean }>(fbFunctions, "deleteInvite");
  return (await fn({ boardUid, requestorUid })).data.success;
}
